import "./upskilling-readiness-report.css"

// Short Report: Upskilling Readiness (Department vs Department)
const UpskillingReadinessReport = (props) => {
  // Prefer the actual prop from parent, but keep fallbacks for safety
  const comparisonResult = props?.comparisonData ?? props?.comparisonResult ?? null;

  console.log("Upskilling Readiness Comparison Result:", comparisonResult)

  const data = comparisonResult?.upskillingReadinessShortReport || {}
  const deptDetails = comparisonResult?.detailedReport?.departmentDetails || {}
  const deptAName = deptDetails?.deptA?.name || "Department A"
  const deptBName = deptDetails?.deptB?.name || "Department B"

  const a = data?.deptAUpskillingReadinessData || {}
  const b = data?.deptBUpskillingReadinessData || {}

  const aAvg = Number(a?.avgScore ?? 0)
  const bAvg = Number(b?.avgScore ?? 0)

  const aCounts = a?.upskillingData || {}
  const bCounts = b?.upskillingData || {}

  const getCount = (obj, key) => Number(obj?.[key] ?? 0)
  const clamp = (v) => Math.max(0, Math.min(100, Number.isFinite(v) ? v : 0))

  return (
    <div className="dd-usr-short-report-container">
      <div className="dd-usr-report-header">
        <h3>Upskilling Readiness</h3>
        <p>Assessment of average upskilling scores and readiness levels between departments</p>
      </div>

      <div className="dd-usr-comparison-summary">
        {/* Department A cards */}
        <div className="dd-usr-summary-card">
          <div className="dd-usr-summary-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
            </svg>
          </div>
          <div className="dd-usr-summary-content">
            <div className="dd-usr-summary-value">{getCount(aCounts, "Critical")}</div>
            <div className="dd-usr-summary-label">{`${deptAName} - Critical Priority`}</div>
          </div>
        </div>

        <div className="dd-usr-summary-card">
          <div className="dd-usr-summary-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" />
            </svg>
          </div>
          <div className="dd-usr-summary-content">
            <div className="dd-usr-summary-value">{getCount(aCounts, "High")}</div>
            <div className="dd-usr-summary-label">{`${deptAName} - High Priority`}</div>
          </div>
        </div>

        <div className="dd-usr-summary-card">
          <div className="dd-usr-summary-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6" />
              <path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18" />
              <path d="M4 22h16" />
              <path d="M10 14.66V17c0 .55.47.98.97 1.21C12.04 18.75 13 19.5 14 19.5s1.96-.75 3.03-1.29c.5-.23.97-.66.97-1.21v-2.34" />
              <path d="M18 2H6v7a6 6 0 0 0 12 0V2Z" />
            </svg>
          </div>
          <div className="dd-usr-summary-content">
            <div className="dd-usr-summary-value">{getCount(aCounts, "Moderate")}</div>
            <div className="dd-usr-summary-label">{`${deptAName} - Moderate Priority`}</div>
          </div>
        </div>

        <div className="dd-usr-summary-card">
          <div className="dd-usr-summary-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="12" r="10" />
              <path d="M12 6v6l4 2" />
            </svg>
          </div>
          <div className="dd-usr-summary-content">
            <div className="dd-usr-summary-value">{getCount(aCounts, "Low")}</div>
            <div className="dd-usr-summary-label">{`${deptAName} - Low Priority`}</div>
          </div>
        </div>

        {/* Department B cards */}
        <div className="dd-usr-summary-card">
          <div className="dd-usr-summary-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
            </svg>
          </div>
          <div className="dd-usr-summary-content">
            <div className="dd-usr-summary-value">{getCount(bCounts, "Critical")}</div>
            <div className="dd-usr-summary-label">{`${deptBName} - Critical Priority`}</div>
          </div>
        </div>

        <div className="dd-usr-summary-card">
          <div className="dd-usr-summary-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" />
            </svg>
          </div>
          <div className="dd-usr-summary-content">
            <div className="dd-usr-summary-value">{getCount(bCounts, "High")}</div>
            <div className="dd-usr-summary-label">{`${deptBName} - High Priority`}</div>
          </div>
        </div>

        <div className="dd-usr-summary-card">
          <div className="dd-usr-summary-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6" />
              <path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18" />
              <path d="M4 22h16" />
              <path d="M10 14.66V17c0 .55.47.98.97 1.21C12.04 18.75 13 19.5 14 19.5s1.96-.75 3.03-1.29c.5-.23.97-.66.97-1.21v-2.34" />
              <path d="M18 2H6v7a6 6 0 0 0 12 0V2Z" />
            </svg>
          </div>
          <div className="dd-usr-summary-content">
            <div className="dd-usr-summary-value">{getCount(bCounts, "Moderate")}</div>
            <div className="dd-usr-summary-label">{`${deptBName} - Moderate Priority`}</div>
          </div>
        </div>

        <div className="dd-usr-summary-card">
          <div className="dd-usr-summary-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="12" r="10" />
              <path d="M12 6v6l4 2" />
            </svg>
          </div>
          <div className="dd-usr-summary-content">
            <div className="dd-usr-summary-value">{getCount(bCounts, "Low")}</div>
            <div className="dd-usr-summary-label">{`${deptBName} - Low Priority`}</div>
          </div>
        </div>
      </div>

      {/* Average Upskilling Readiness Metrics */}
      <div className="dd-usr-metrics-comparison">
        <h3>Average Upskilling Readiness Score</h3>
        <div className="dd-usr-metrics-chart">
          <div className="dd-usr-metric-bar-container">
            <div className="dd-usr-metric-info">
              <span className="dd-usr-metric-name">{`${deptAName} Department`}</span>
            </div>
            <div className="dd-usr-metric-bar">
              <div className="dd-usr-metric-fill" style={{ width: `${clamp(aAvg)}%` }} />
              <span className="dd-usr-metric-value">{`${aAvg.toFixed(2)}%`}</span>
            </div>
          </div>

          <div className="dd-usr-metric-bar-container">
            <div className="dd-usr-metric-info">
              <span className="dd-usr-metric-name">{`${deptBName} Department`}</span>
            </div>
            <div className="dd-usr-metric-bar">
              <div className="dd-usr-metric-fill" style={{ width: `${clamp(bAvg)}%` }} />
              <span className="dd-usr-metric-value">{`${bAvg.toFixed(2)}%`}</span>
            </div>
          </div>
        </div>
      </div>

      {/* Analysis Overview */}
      <div className="dd-usr-insights-section">
        <h3>Analysis Overview</h3>
        <div className="dd-usr-analysis-paragraph">
          <p>{data?.overview || "No analysis available."}</p>
        </div>
      </div>
    </div>
  )
}

export default UpskillingReadinessReport
